import { EsDataType } from '../enums';

export const iorNumber = {
  default: true,
  name: 'IOR #',
  type: EsDataType.KEYWORD,
};
